import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../../../modules/auth/auth.service';

@Component({
    selector: 'app-token-request',
    templateUrl: './token-request.component.html',
    styleUrls: ['./token-request.component.scss'],
})
export class TokenRequestComponent implements OnInit {
    form: FormGroup;
    /**
     * Usuário para qual será solicitado o token
     */
    @Input('player') player: string;

    /**
     * Tipo de solicitação do token  0 - recuperação de senha | 1 - cadastro | 2 - cancelamento de inscrição
     */
    @Input('type') type: '0' | '1' | '2';

    /**
     * Extra data
     */
    @Input('extra') extra: Record<string, string>;

    /**
     * Evento emitido após requisição do token ser executada com sucesso
     */
    @Output('sent') sent: EventEmitter<{ code: string; type_sending: string }> = new EventEmitter();

    /**
     * Flag de loading
     */
    loading = false;

    constructor(private authService: AuthService, private formBuilder: FormBuilder) {}

    ngOnInit(): void {
        this.buildForm();
        console.log(this.player);
    }

    onRequestToken() {
        if (!this.player) return console.error('ID do usuário `[player]` não recebido.');
        const { player, type_sending } = this.form.value;
        this.loading = true;
        this.authService.requestToken(player, type_sending, this.type, this.extra).subscribe((response) => {
            this.loading = false;
            const success = response.status_code === 0;

            if (success) {
                this.sent.emit({ code: response.registers.code_token, type_sending });
                return;
            }
        });
    }

    buildForm() {
        this.form = this.formBuilder.group({
            player: new FormControl(this.player, Validators.required),
            type_sending: new FormControl('', Validators.required),
        });
    }
}
